import { NavCard } from "../../v2024/card"
import { Link } from "gatsby"
import CardPost from "../../v2023/UI/Card/card-post"
import React from "react"

export const SolutionsSection = ({ title, items, stories }) => {
    return (
        <li className="menu-options__options__option">
            <span>{title}</span>
            <div className="option__menu">
                <div className="container">
                    <div className="option__menu__section">
                        {items.map((item, index) =>
                            <div key={item.id} className={`section__column ${index === 0 ? "section__column--lg" : ""}`}>
                                <span className="section__column__title">{item.section_title}</span>
                                {index === 0 ? (
                                    <div className="grid grid-xs-2">
                                        {item.section_items.map(element => (
                                            element.image ? (
                                                <NavCard
                                                    key={element.title}
                                                    title={element.title} link={element.url} icon={element.image}
                                                    description={element.description} size="lg"
                                                />
                                            ) : (
                                                <NavCard
                                                    key={element.title}
                                                    title={element.title} link={element.url}
                                                    description={element.description} size="sm"
                                                />
                                            )
                                        ))}
                                    </div>
                                ) : (
                                    <div className="card-group">
                                        {item.section_items.map(element => (
                                            element.image ? (
                                                <NavCard
                                                    key={element.title}
                                                    title={element.title} link={element.url} icon={element.image}
                                                    description={element.description} size="lg"
                                                />
                                            ) : (
                                                <NavCard
                                                    key={element.title}
                                                    title={element.title} link={element.url}
                                                    description={element.description} size="sm"
                                                />
                                            )
                                        ))}
                                    </div>
                                )}
                                <Link className="section__column__view-more" to={item.see_all.url}>{item.see_all.text}</Link>
                            </div>
                        )}
                    </div>
                    <div className="option__menu__section option__menu__section--gray">
                        <div className="section__column">
                            <span className="section__column__title">{stories.title}</span>
                            {stories.customer_card.map((card, index) => {
                                return <CardPost
                                    key={index}
                                    name={card.description}
                                    image={card.image}
                                    horizontal
                                    url={card.url}
                                    size="xs"
                                />
                            })}
                            <Link className="section__column__view-more" to={stories.see_all.url}>{stories.see_all.text}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}